import {useFloatingSelectContext, useSelectContext} from '../../context'
import {SelectItemLayout} from '../select_item_layout'

export const SelectItem = ({item}) => {
	const {value, single, multiple, updateValue, ItemComponent, readOnly, itemHeight} = useSelectContext()
	const {activeIndex, getItemProps} = useFloatingSelectContext()
	const {data, originalIndex} = item

	const {value: itemValue, label, ...itemRest} = data
	const selected = single ? value === itemValue : value.includes(itemValue)
	const active = activeIndex === originalIndex || (single && value === itemValue)

	// getItemProps returns props for item elements in a list, like onFocus, onMouseMove and onPointerLeave
	// which enables list navigation
	const itemProps =
		!readOnly &&
		getItemProps({
			onClick: () => updateValue(data),
		})

	return (
		<SelectItemLayout
			{...itemRest}
			item={data}
			originalIndex={originalIndex}
			ItemComponent={ItemComponent}
			height={itemHeight}
			active={active}
			checkboxProps={
				(multiple || ItemComponent) && {
					checked: selected,
					disabled: data.disabled,
				}
			}
			{...itemProps}
		>
			{label}
		</SelectItemLayout>
	)
}
